import { render, staticRenderFns } from "./header-nav.vue?vue&type=template&id=16aff0a2&scoped=true&"
import script from "./header-nav.vue?vue&type=script&lang=js&"
export * from "./header-nav.vue?vue&type=script&lang=js&"
import style0 from "./header-nav.vue?vue&type=style&index=0&id=16aff0a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aff0a2",
  null
  
)

export default component.exports